import { render } from "./RaffleDetailsPage.vue?vue&type=template&id=11860b9b&scoped=true"
import script from "./RaffleDetailsPage.vue?vue&type=script&lang=js"
export * from "./RaffleDetailsPage.vue?vue&type=script&lang=js"

import "./RaffleDetailsPage.vue?vue&type=style&index=0&id=11860b9b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11860b9b"]])

export default __exports__